var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.authProviders),function(link){return _c('v-btn',{key:link.icon,staticClass:"me-2",attrs:{"color":link.color,"dark":"","icon":"","outlined":"","loading":_vm.loading,"disabled":_vm.loading},on:{"click":function($event){return _vm.signInWithAuth(link.provider)}}},[_c('v-icon',[_vm._v(" "+_vm._s(link.icon)+" ")])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }